import { Box, type BoxProps, Column, Row } from '@stenajs-webui/core';
import { Label } from '@stenajs-webui/elements';
import { type FC, type ReactNode, useId } from 'react';
import { getApprovalInfo } from '../../common/utils/approvalInfo';
import type { GoodsApproval } from '../../common/utils/GoodsApproval';
import { ApproveAlert } from '../ApproveAlert';

export interface DetailsFieldCellProps
  extends Pick<BoxProps, 'flex' | 'width' | 'maxWidth' | 'minWidth' | 'className'> {
  approved?: GoodsApproval;
  contentLeft?: ReactNode;
  contentRight?: ReactNode;
  label: string;
  maxCharacters?: number;
  renderField: (id: string) => ReactNode;
}

export const DetailsFieldCell: FC<DetailsFieldCellProps> = ({
  approved,
  label,
  renderField,
  contentLeft,
  contentRight,
  maxCharacters,
  ...props
}) => {
  const id = useId();

  const approvalInfo = approved ? getApprovalInfo(approved) : null;

  return (
    <Column {...props} gap>
      <Row alignItems={'center'} gap>
        {contentLeft}
        <Row>
          <Label text={label} htmlFor={id} maxCharacters={maxCharacters} />
        </Row>
        {contentRight}
      </Row>
      <Row alignItems={'center'} gap>
        <Box flex={1}>{renderField(id)}</Box>
        {approvalInfo && <ApproveAlert config={approvalInfo} />}
      </Row>
    </Column>
  );
};
